/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Launch_A_StorefrontInputs */

const en_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a storefront`)
};

const es_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzar una tienda`)
};

const fr_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer une vitrine`)
};

const de_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Storefront starten`)
};

const ja_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを立ち上げる`)
};

const zh_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动一个店铺`)
};

const ar_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إطلاق واجهة متجر`)
};

const id_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan etalase`)
};

const it_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanciare una vetrina`)
};

const ru_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустить витрину`)
};

const pt_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançar uma vitrine`)
};

const ko_launch_a_storefront = /** @type {(inputs: Launch_A_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 런칭`)
};

/**
* | output |
* | --- |
* | "Launch a storefront" |
*
* @param {Launch_A_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const launch_a_storefront = /** @type {((inputs?: Launch_A_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Launch_A_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_launch_a_storefront(inputs)
	if (locale === "es") return es_launch_a_storefront(inputs)
	if (locale === "fr") return fr_launch_a_storefront(inputs)
	if (locale === "de") return de_launch_a_storefront(inputs)
	if (locale === "ja") return ja_launch_a_storefront(inputs)
	if (locale === "zh") return zh_launch_a_storefront(inputs)
	if (locale === "ar") return ar_launch_a_storefront(inputs)
	if (locale === "id") return id_launch_a_storefront(inputs)
	if (locale === "it") return it_launch_a_storefront(inputs)
	if (locale === "ru") return ru_launch_a_storefront(inputs)
	if (locale === "pt") return pt_launch_a_storefront(inputs)
	return ko_launch_a_storefront(inputs)
});